import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftBoxResponse } from '@models/gift';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import giftImg from './img.png';

interface Props {
    giftBox: GiftBoxResponse
}

function GiftInfo({ giftBox }:Props) {
    const { receiverName, giftCard, giftCoupon } = giftBox;
    const { t } = useTranslation('gift');
    return (
        <Container as='section' fullWidth
            align='center' >
            <HeaderImage src={giftImg}
                width={225}
                height={112}
                alt={t('giftInfo.imageAlt')} />
            <Comment size='3xl'
                fontWeight='bold' >
                {t('giftInfo.sentMessage', { name: receiverName })}
            </Comment>
            {giftCard && (
                <Fragment>
                    <Card src={giftCard.imageUrl}
                        width={200}
                        height={134}
                        alt='' />
                    <Name color={colors.gray7} size='xl' fontWeight='bold' >
                        {giftCard.name}
                    </Name>
                </Fragment>
            )}
            {giftCoupon && (
                <Fragment>
                    <Item>
                        <Image src={giftCoupon.imageUrl}
                            alt={giftCoupon.name}
                            width={72}
                            height={72} />
                    </Item>
                    <Name color={colors.gray7} size='xl' fontWeight='bold' >
                        {giftCoupon.name}
                    </Name>
                </Fragment>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 48px 20px 0;
`;

const HeaderImage = styled(Image)`
    transform: translateX(5%);
`;

const Comment = styled(Text)`
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
`;

const Card = styled(Image)`
    border-radius: 8px;
    filter: drop-shadow(0 1.994px 15.952px rgba(0, 0, 0, 0.14));
`;

const Item = styled.div`
    align-items: center;
    border-radius: 12px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
    display: flex;
    height: 100px;
    justify-content: center;
    width: 100px;
`;

const Name = styled(Text)`
    margin: 14px 0 20px;
`;

export default GiftInfo;
